<template>
  <div class="text-center">
  	<div class="border border-primary rounded-circle text-primary">
			<font-awesome-icon icon="exclamation-triangle" class="fa-3x"/>
			<font-awesome-icon icon="map" class="fa-7x"/>
  	</div>
  	<br>
  	<h3>Sorry :(</h3>
    <h4>Contact us if you need a trip to this zone at:
      <br><strong> {{ this.settings.contactPhone }} </strong>
      <br> we can get you there!
    </h4>
    <Navigation only-back></Navigation>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Navigation from './Navigation.vue'

export default {
  name: 'Sorry',
  components: {
    Navigation
  },
  props: {
  },
  data: () => {
  	return {
  	}
  },
  computed: {
    ...mapState(['settings']),
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.border{
		border-width: 5px !important;
		width: 250px;
		height: 250px;
		margin: 0 auto;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}
</style>
